export enum RedeemCodeScreenSectionKey {
  reedemCode = "reedemCode",
  success = "success",
}
